import {
    RACING_LOADING,
    RACING_LOADING_SUCCESS,
    RACING_LOADING_ERROR,
    RACING_LOADED_EMPTY,
} from './types';

export const racingLoading = () => ({
    type: RACING_LOADING,
});

export const loadSuccess = () => ({
    type: RACING_LOADING_SUCCESS,
});

export const hasErrored = () => ({
    type: RACING_LOADING_ERROR,
});

export const scheduleIsEmpty = () => ({ type: RACING_LOADED_EMPTY });
